





















































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import useAuth, { tokenName } from '@/useAuth';

import { changePassword } from '@/api';

const Profile = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  setup() {
    const { router } = useRouter();
    const { hasPermission, getMe } = useAuth();
    const successModal = ref(null);
    const form = reactive({
      name: '',
      email: '',
      telephone: '',
      employeeCode: 'ไม่มีรหัสพนักงาน',
      newPassword: '',
      newPasswordConfirm: '',
      currentPassword: '',
      // HACK: check exist email doesn't work yet.
      failSafeEmail: '',
      call: async () => {
        const result = await changePassword(
          form.newPassword,
          form.currentPassword,
        );
        if (result === true) {
          localStorage.removeItem(tokenName);
          (successModal.value as any).compose({
            primaryAction: 'เข้าสู่ระบบใหม่',
            action: 'เปลี่ยน',
            entity: 'รหัสผ่านเรียบร้อย',
            dismiss: null,
          });
        }
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(async () => {
      const me = await getMe();
      form.name = me.name;
      form.email = me.email;
      form.telephone = me.telephone;
      // form.employeeCode = me.employeeCode;
    });

    return {
      hasPermission,
      form,
      successModal,
    };
  },
});

export default Profile;
